export function getHistoricMovementNumber(
  totalItems: number,
  descSortedIndex: number,
): number {
  return totalItems - descSortedIndex;
}
